import { LockKey, CalendarCheck, Timer, CheckCircle } from '@phosphor-icons/react';
import { useDetox, formatCountdown, formatDateRu, DETOX_ALLOWED_DATES } from '../../utils/detox.js';

interface DetoxLockProps {
  /** название заблокированного раздела, например «Курсы» */
  sectionName: string;
}

/**
 * Заглушка детокс-режима: раздел закрыт, показываем обратный отсчёт
 * до следующего разрешённого дня и расписание открытых дат (МСК).
 */
export function DetoxLock({ sectionName }: DetoxLockProps) {
  const detox = useDetox();
  const next = detox.upcoming[0];

  return (
    <div class="detox-lock">
      <div class="detox-lock-screen">
        <div class="detox-lock-icon">
          <LockKey size={40} weight="duotone" />
        </div>

        <h2 class="detox-lock-title">Просмотр ограничен</h2>
        <p class="detox-lock-sub">
          Детокс-режим: раздел «{sectionName}» открывается только по расписанию —
          на весь день по московскому времени.
        </p>

        {detox.msToOpen > 0 && next ? (
          <>
            <div class="detox-count-label">
              <Timer size={14} weight="duotone" /> до открытия
            </div>
            <div class="detox-count">{formatCountdown(detox.msToOpen)}</div>
            <div class="detox-next">
              откроется <strong>{formatDateRu(next)}</strong> в 00:00 МСК
            </div>
          </>
        ) : (
          <div class="detox-next">Новых дат в расписании нет — добавьте следующие окна в коде.</div>
        )}

        <div class="detox-dates">
          <div class="detox-dates-label">
            <CalendarCheck size={14} weight="duotone" /> дни открытого просмотра
          </div>
          <div class="detox-dates-list">
            {DETOX_ALLOWED_DATES.map((d) => {
              const isPassed = detox.passed.includes(d);
              return (
                <span key={d} class={`detox-date-chip${isPassed ? ' passed' : ''}`}>
                  {isPassed && <CheckCircle size={13} weight="fill" />}
                  {formatDateRu(d)}
                </span>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

/** Тонкий баннер в открытый день: напоминает, что окно до конца дня */
export function DetoxOpenBanner() {
  const detox = useDetox();
  if (!detox.open) return null;
  return (
    <div class="detox-open-banner">
      <CalendarCheck size={14} weight="duotone" />
      <span>
        Сегодня день открытого просмотра — окно закроется через{' '}
        <strong>{formatCountdown(detox.msToClose)}</strong> (в 00:00 МСК)
      </span>
    </div>
  );
}
